<script>
export default {
    props: {
        item: { type: Object, default () {} }
    }
}
</script>
<template>
    <span>
        <span v-for="i in item.record" :key="i.key">
            <!-- issue 213 -->
            <span v-if="i.key.trim() !== 'Uuid'">
                <span v-if="i.key !== 'Shipment Uuid'">
                    <i style="opacity:0.5">{{ i.key }} :</i> <span>{{ i.value }}</span> <br/>
                </span>
                <span v-else>
                    <i v-if="item.request && item.request.shipment_id" style="opacity:0.5">Shipment ID :</i> <span>{{ item.request.shipment_id }}</span> <br/>
                </span>
            </span>
            <!-- issue 213 -->
        </span>
    </span>
</template>